import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import router from '@/router/index'
// import { Loading } from 'element-ui';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
//默认请求头  并 指向原型
//
axios.defaults.baseURL = process.env.BASE_API;
// axios.defaults.withCredentials = true; // 让ajax携带cookie
Vue.prototype.path = process.env.BASE_API;
Vue.prototype.pathImg = process.env.PATH_IMG;

// axios.defaults.baseURL = 'http://www.fintechbj.com/api';
// // axios.defaults.withCredentials = true; // 让ajax携带cookie
// Vue.prototype.path = 'http://www.fintechbj.com/api';
// Vue.prototype.pathImg = 'http://hry-exchange-public.oss-cn-beijing.aliyuncs.com/';
//song
// axios.defaults.baseURL = 'http://192.168.0.52:7770';
// Vue.prototype.path = 'http://192.168.0.52:7770';
// Vue.prototype.pathImg = 'http://hry-exchange-public.oss-cn-beijing.aliyuncs.com/';

//chen
// axios.defaults.baseURL = 'http://172.16.10.136:8083/hry_web_app';
// Vue.prototype.path = 'http://172.16.10.136:8083/hry_web_app';
// Vue.prototype.pathImg = 'http://hry-exchange-public.oss-cn-beijing.aliyuncs.com/';


// axios.defaults.baseURL = 'http://172.16.80.81:6005/app';
// Vue.prototype.path = 'http://172.16.80.81:6005/app';
// Vue.prototype.pathImg = 'http://hry-exchange-public.oss-cn-beijing.aliyuncs.com/';


// axios.defaults.baseURL = 'localhost:6005/app';
// Vue.prototype.path = 'localhost:6005/app';
// Vue.prototype.pathImg = 'http://hry-exchange-public.oss-cn-beijing.aliyuncs.com/';

// let loading = null;
let loadingOpenCount = 0;
//获取cookie
function getCookie(c_name) {
  if (document.cookie.length>0)
  {
    var c_start=document.cookie.indexOf(c_name + "=");
    if (c_start!=-1)
    {
      c_start=c_start + c_name.length+1
      var c_end=document.cookie.indexOf(";",c_start);
      if (c_end==-1) c_end=document.cookie.length;
      return unescape(document.cookie.substring(c_start,c_end))
    }
  }
  return ""
}
//设置coolie
function setCookie(c_name,value,day){
  var exdate = new Date();
  exdate.setTime(exdate.getTime() + day*24*60*60*1000);
  document.cookie= c_name + "=" + value +((day==null) ? "" : ";expires="+exdate.toGMTString());
}
//删除cookie
function delCookie(c_name){
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval=getCookie(c_name);
  if(cval!=null) {
    document.cookie= c_name + "="+cval+";" +
      "expires="+exp.toGMTString();
  }
}
var token = getCookie('token');
axios.interceptors.request.use(function (config) {
   // config.headers.common['csrfToken'] = sessionStorage.getItem('csrfToken');
  // if (config.showLoading != false && config.method != 'OPTIONS') {
  //   []
  //   loadingOpenCount++;
  // }
  // if (config.showLoading != false && loadingOpenCount == 1 && config.method != 'OPTIONS') {
  //   open();
  // }

  //如果cookie里面有值 就传token
  if (localStorage.getItem('token')) {
    config.headers.common['token'] = localStorage.getItem('token');
  }
  else{
    if(token != ''){
      config.headers.common['token'] = token
    }
  }
  if (config.method === 'post') {
    config.data = qs.stringify(config.data);
  }
  if (config.method === 'get') {
    config.url = config.url + "?" + qs.stringify(config.data);
  }
  if (config.method === 'upload') {
    config.method = 'post';
  }
  return config
}, function (error) {
  return Promise.reject(error)
});
axios.interceptors.response.use(
  response => {
    // if (response.config.showLoading != false && response.config.showLoading != false && response.config.method != 'OPTIONS') {
    //   loadingOpenCount--;
    //   if (loadingOpenCount == 0) {
    //     setTimeout(function () {
    //       close();
    //     }, 0.3 * 1000)
    //   }
    // }
    if(response.headers.authorization != undefined){
      localStorage.setItem('token',response.headers.authorization) ;
      setCookie('token',response.headers.authorization,1)
    }
    else if (response.data.code == 401) {// 判断返回的数据里面code资源
      delCookie('token');
			delCookie('Language');
      router.push({
        path: '/login', name: 'login'
        , params: { 'error': response.data.tokenMsg }
      });
      // close();
    }
    return response;
  },
  error => {
    // close();
    // //  	请求异常处理
    //             switch (error.response.status) {
    //                 case 401:
    //                     router.push({path:'/Login',name:'Login'
    //                     ,params: {'error': 'token失效,请重新登陆'}
    //                     })
    //                    }
    if(error.response == undefined){
      return {data: {success: false, msg: '请求异常'}};
    }else{
      return checkStatus(error.response);
    }

    if (error.response && error.response.data) {
      return Promise.reject(error.response.data)
    }
    // 返回接口返回的错误信息
  });
// function getConfig(config){
// 	return config;
// }
// function open() {
//   loading = Loading.service({
//     lock: false,
//     text: '拼命加载中...',
//     spinner: 'el-icon-loading',
//     background: 'rgba(0, 0, 0, 0.7)'
//   });
// }
// function close() {
//   if (loading) {
//     loading.close();
//   }
// }

// 检查状态
function checkStatus(response) {
  let data = {data: {}};
  data.data['success'] = false;
  switch (response.status) {
    case 400:
      data.data['msg'] = '请求错误'
      break

    case 401:
      data.data['msg'] = '未授权，请登录'
      break

    case 403:
      data.data['msg'] = '拒绝访问'
      break

    case 404:
      data.data['msg'] = '请求地址出错'
      break

    case 408:
      data.data['msg'] = '请求超时'
      break

    case 500:
      data.data['msg'] = '服务器内部错误'
      break

    case 501:
      data.data['msg'] = '服务未实现'
      break

    case 502:
      data.data['msg'] = '网关错误'
      break

    case 503:
      data.data['msg'] = '服务不可用'
      break

    case 504:
      data.data['msg'] = '网关超时'
      break

    case 505:
      data.data['msg'] = 'HTTP版本不受支持'
      break

    default:
      data.data['msg'] = '异常请求';
  }
  return data;
}



// WEBPACK FOOTER //
// ./src/utils/axios.js